import { CustomerStatus } from "Store/userIdentification/userIdentificationInterfaces";

const unwanted = [CustomerStatus.NOT_OK, CustomerStatus.CUSTOMER_TOO_YOUNG];
export const isUnwanted = (
  customerStatus: CustomerStatus | undefined,
): boolean => {
  return unwanted.includes(customerStatus as CustomerStatus);
};
